import SearchLabel from './SearchLabel';

export default SearchLabel;
